"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KanbanMain = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const kanban_main_style_1 = __importDefault(require("./kanban.main.style"));
const loader_1 = require("../../loader");
class KanbanMain extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, lightTheme, greyTheme, loading } = this.props;
            return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "aria-busy": loading }, { children: children }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classnames_1.default(classes.bg, {
                            [classes.bgLightTheme]: lightTheme,
                            [classes.bgGreyTheme]: greyTheme
                        }), role: "none" }, { children: greyTheme ? (jsx_runtime_1.jsx("div", Object.assign({ className: classes.bgLoader, "data-loading": loading }, { children: jsx_runtime_1.jsx(loader_1.LoaderTraceLogo, { light: lightTheme }, void 0) }), void 0)) : (jsx_runtime_1.jsx("div", Object.assign({ className: classes.bgImage, role: "none" }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.bgLoader, "data-loading": loading }, { children: jsx_runtime_1.jsx(loader_1.LoaderTraceLogo, { light: lightTheme }, void 0) }), void 0) }), void 0)) }), void 0)] }, void 0));
        };
    }
}
exports.KanbanMain = KanbanMain;
KanbanMain.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node,
    lightTheme: prop_types_1.default.bool,
    greyTheme: prop_types_1.default.bool,
    loading: prop_types_1.default.bool
};
KanbanMain.defaultProps = {
    lightTheme: false,
    greyTheme: false,
    children: null,
    loading: false
};
exports.default = react_jss_1.default(kanban_main_style_1.default)(KanbanMain);
//# sourceMappingURL=kanban.main.js.map